import React from 'react';
import { FormContext } from 'react-hook-form';
import { Trans } from '@lingui/macro';
import { noop } from 'lodash';

import AuthenticationContainer from '@src/components/AuthenticationContainer';
import AuthenticationScrollView from '@src/components/AuthenticationScrollView';
import AuthenticationSendButton from '@src/components/AuthenticationSendButton';
import OTPInput from '@src/components/OTPInput';
import { Row } from '@src/components/Score/styled';
import Separator from '@src/components/Separator';
import VisibleStatusBar from '@src/components/VisibleStatusBar';

import { Container, Remaining, TextButton, Title, Wrapper } from './styled';
import { Props } from './types';
import useForm from './useForm';

const Screen: React.FC<Props> = ({ navigation, route }) => {
  const { form, handleSubmit, loading, ttl, resendCode } = useForm();

  const handleResendCode = React.useCallback(async () => {
    await resendCode();
  }, [resendCode]);

  return (
    <>
      <VisibleStatusBar />
      <AuthenticationContainer style={{ flex: 1 }}>
        <AuthenticationScrollView>
          <Container>
            <Wrapper>
              <FormContext {...form}>
                <Title>
                  <Trans>Code sent to {route.params.phone}</Trans>
                </Title>
                <OTPInput
                  autoFocus
                  disabled={loading}
                  onSubmitEditing={handleSubmit}
                  name="token"
                />
                <Separator />
              </FormContext>
              <Wrapper>
                <Row>
                  <TextButton
                    disabled={ttl > 0}
                    onPress={ttl <= 0 ? handleResendCode : noop}
                  >
                    {ttl > 0 ? (
                      <Remaining>
                        <Trans>Send again in {ttl}s</Trans>
                      </Remaining>
                    ) : (
                      <Trans>Resend Code</Trans>
                    )}
                  </TextButton>
                </Row>
                <Row>
                  <TextButton onPress={() => navigation.goBack()}>
                    <Trans>Change Phone Number</Trans>
                  </TextButton>
                </Row>
              </Wrapper>
            </Wrapper>
            <Wrapper>
              <AuthenticationSendButton
                onPress={handleSubmit}
                loading={loading}
                disabled={loading}
              >
                <Trans>Confirm code</Trans>
              </AuthenticationSendButton>
            </Wrapper>
          </Container>
        </AuthenticationScrollView>
      </AuthenticationContainer>
    </>
  );
};

Screen.displayName = 'SignUpOTP';

export default Screen;
